import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 0,
  class: "text-primary h-4 w-4 shrink-0"
}
const _hoisted_3 = {
  key: 0,
  class: "first:text-primary"
}
const _hoisted_4 = {
  key: 1,
  class: "inline-flex items-center gap-2"
}
const _hoisted_5 = { class: "text-foreground" }

import { ChevronRight } from 'lucide-vue-next';
    import {
        Dashboard,
        Salary,
        Voucher,
        Bank,
        Vat,
        Administration,
        Settings,
        PowerBI,
    } from '@/components/icons';
    import { useI18n } from 'vue-i18n';

    interface Props {
        result: any;
        context: any;
        contextIndex: number;
        resultIndex: number;
        searchQuery: string;
        isSelected: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalSearchResult',
  props: {
    result: {},
    context: {},
    contextIndex: {},
    resultIndex: {},
    searchQuery: {},
    isSelected: { type: Boolean }
  },
  emits: ["navigate"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emit = __emit;

    const getIconForBreadcrumb = (breadcrumbKey: string) => {
        const iconMap = {
            'menu.dashboards': Dashboard,
            'menu.salary': Salary,
            'menu.voucher': Voucher,
            'menu.bank': Bank,
            'menu.vat': Vat,
            'menu.administration': Administration,
            'menu.settings': Settings,
            'menu.power_bi': PowerBI,
        };

        return iconMap[breadcrumbKey as keyof typeof iconMap];
    };

    const handleClick = (event: Event) => {
        event.preventDefault();
        emit('navigate', props.context);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.context.url,
    class: _normalizeClass([_ctx.isSelected ? 'bg-muted' : 'hover:bg-muted/50', "text-faded-foreground flex items-center gap-2 rounded-md px-2 py-1.5 text-sm font-normal transition-colors"]),
    onClick: handleClick
  }, [
    (getIconForBreadcrumb(_ctx.context.breadcrumb[0]))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(getIconForBreadcrumb(_ctx.context.breadcrumb[0])), { class: "text-primary h-full w-full" }))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.breadcrumb, (crumb, index) => {
      return (_openBlock(), _createElementBlock("span", {
        key: index,
        class: "inline-flex items-center gap-2"
      }, [
        (index > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createVNode(_unref(ChevronRight), { class: "h-3 w-3" })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass(
                    _ctx.result.name && _ctx.result.name.trim()
                        ? 'first:text-primary text-faded-foreground'
                        : 'first:text-primary text-foreground'
                )
        }, _toDisplayString(_ctx.$t(crumb)), 3)
      ]))
    }), 128)),
    (_ctx.result.name && _ctx.result.name.trim())
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createVNode(_unref(ChevronRight), { class: "h-3 w-3" }),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.result.name), 1)
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})